import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { NavigationExtras, Router } from '@angular/router';
import { UserAuthentified } from '@app/authentification/user-authentified.interface';
import { AttributionDao } from '@app/dao/attribution/attribution.dao';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { UserService } from '@app/providers/user/user.service';
import { SimulationService } from '@app/services/simulation.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {
  catchError,
  finalize,
  switchMap,
  takeWhile,
  tap,
} from 'rxjs';
export interface rdvBody {
  title?: string;
  content?: string;
  labelBtn?: string;
  altTitle?: string;
  altContent?: string;
  altLabelBtn?: string;
}
@Component({
    selector: 'ea-rdv-card',
    templateUrl: './ea-rdv-card.component.html',
    styleUrls: ['./ea-rdv-card.component.scss'],
    standalone: false
})
export class EaRdvCardComponent implements OnInit, OnDestroy {
  @Input() currentScreen: string;
  @Input() productInfo: string;
  @Input() productLabel: string;
  @Input() productLabelInfo: string;
  @Input() customLabel: boolean;
  @Input() name: string;
  @Input() productType: string;
  @Input() automatic: boolean = true;
  @Input() productId: number;

  isSubscrible: boolean = true;
  bodyScpi: rdvBody = {
    title: "Envie d'investir dans ce portefeuille ?",
    labelBtn: 'Souscrire en ligne',
    altContent:
      ' Faites vous accompagner par votre conseiller pour choisir les SCPI les plus adapatées a votre projet. ',
    altTitle: "Besoin d'aide pour choisir vos SCPI ?",
    altLabelBtn: 'Prendre rendez-vous',
  };

  bodyAv: rdvBody = {
    title: "Envie d'investir dans ce portefeuille ?",
    labelBtn: 'Souscrire en ligne',
    altContent:
      'Faites vous accompagner par votre conseiller pour choisir les supports les plus adaptés a votre projet. ',
    altTitle: "Besoin d'accompagnement pour souscrire en assurance-vie ? ",
    altLabelBtn: 'Prendre rendez-vous',
  };

  bodyPer: rdvBody = {
    title: "Envie d'investir dans ce portefeuille ?",
    labelBtn: 'Souscrire en ligne',
    altContent:
      'Faites vous accompagner par votre conseiller pour choisir les supports les plus adaptés a votre projet. ',
    altTitle: "Besoin d'accompagnement pour souscrire votre PER ? ",
    altLabelBtn: 'Prendre rendez-vous',
  };

  bodyAssets: rdvBody = {
    title: 'Vous souhaitez être accompagné dans votre projet ?',
    labelBtn: 'Prendre rendez-vous',
    altContent:
      'Faites vous accompagner par votre conseiller pour choisir la solution la plus adaptée.',
    altTitle: "Besoin d'accompagnement ? C'est gratuit et sans engagement",
    altLabelBtn: 'Prendre rendez-vous',
  };

  body: rdvBody = {
    title: 'Vous souhaitez être accompagné dans votre projet ?',
    labelBtn: 'Souscrire en ligne',
    altContent: 'Faites vous accompagner par votre conseiller. ',
    altTitle: "Besoin d'accompagnement ? ",
    altLabelBtn: 'Prendre rendez-vous',
  };

  private userData: UserAuthentified;
  modalRef: BsModalRef;
  hasPhone: boolean;
  submitting = false;
  numberForm: UntypedFormGroup;
  consultant$: any;
  isConsultant: boolean;
  loading: boolean = false;
  private alive = true;
  constructor(
    private fb: UntypedFormBuilder,
    private userService: UserService,
    private modalService: BsModalService,
    private attributionDao: AttributionDao,
    private SubscriptionFacade: SubscriptionFacadeService,
    private SimulationService: SimulationService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.consultant$ = this.userService.getUser().pipe(
      takeWhile(() => this.alive),
      tap(user => {
        if (user) {
          this.userData = user;
          if (user.sessionConsultant) this.isConsultant = true;
          else this.isConsultant = false;
          if (this.userData.contacts) {
            this.hasPhone = !!this.userData.contacts.find(
              elm =>
                (elm.type === 'TEL_FIX' || elm.type === 'TEL_MOB') && elm.value,
            );
          }
        }
      }),
      switchMap(data => {
        return this.attributionDao.getConsultant();
      }),
    );

    this.numberForm = this.fb.group({
      phone: [
        null,
        Validators.compose([
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(12),
          Validators.pattern('[0-9]+'),
        ]),
      ],
    });
  }

  navigateToDashboard() {
    if (this.productType == 'ASSURANCE_VIE') {
      this.loading = true;
      const simulationData = this.SimulationService.getSimulationData();
      const { productType } = simulationData || {};

      this.SubscriptionFacade.initPledge({
        productType,
        portfolioSimulationParameters: simulationData,
        operation: 'SUBSCRIPTION',
      })
        .pipe(
          this.SubscriptionFacade.takeUntilDestroy,
          catchError(error => {
            this.loading = false;
            throw error;
          }),
        )
        .subscribe(pledge => {
          this.loading = false;
          const ownerIds = pledge?.owners?.[0]?.id;
          this.SubscriptionFacade.navigateTo(pledge?.productType, pledge?.id, [
            ownerIds,
          ]);
        });
    } else {
      const queryParams = {
        productType: this.productType,
        productId: this.productId,
      };
      const navigationExtras: NavigationExtras = {
        queryParams,
      };

      this.router.navigate(['/dashboard/souscription/init'], navigationExtras);
    }
  }
  getTypeObject() {
    if (this.productType === 'ASSURANCE_VIE') {
      return this.bodyAv;
    } else if (this.productType === 'SCPI') {
      return this.bodyScpi;
    } else if (this.productType === 'PER') {
      return this.bodyPer;
    } else if (
      this.productType === 'GIRARDIN' ||
      this.productType === 'FIP' ||
      this.productType === 'FCPI' ||
      this.productType === 'LMNP' ||
      this.productType === 'PINEL'
    ) {
      this.isSubscrible = false;
      return this.bodyAssets;
    } else {
      return this.body;
    }
  }
  showModal(event: any, template: TemplateRef<any>): void {
    if (this.hasPhone) {
      this.sentRequestContact();
    }
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'ea-modal-contact' }),
    );
  }

  hideModal() {
    if (this.modalRef) {
      this.modalRef.hide();
      this.modalRef = null;
    }
    this.submitting = false;
  }

  sentRequestContact() {
    // this.submitting = true;
    this.userService
      .requestContact(this.userData.id, {
        currentScreen: this.currentScreen,
        productInfo: this.productInfo,
      })
      .pipe(
        takeWhile(() => this.alive),
        finalize(() => (this.submitting = false)),
      )
      .subscribe(
        () => {
          // this.hasPhone = true;
        },
        err => {
          if (err && err.status === 401) {
            this.hideModal();
          }
        },
      );
  }

  onNumberForm(form: any) {
    if (form.valid) {
      this.submitting = true;
      this.hasPhone = !this.hasPhone;
      let body = {
        id: null,
        isMain: true,
        label: null,
        type: 'TEL_MOB',
        value: form.value.phone,
      };
      this.userService
        .updateContact(this.userData.id, body)
        .pipe(
          takeWhile(() => this.alive),
          finalize(() => (this.submitting = false)),
        )
        .subscribe(
          () => {
            this.sentRequestContact();
            this.hasPhone = true;
          },
          err => {
            if (err && err.status === 401) {
              this.hideModal();
            }
          },
        );
    }
  }

  ngOnDestroy() {
    this.alive = false;
  }
}
